// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"Auth_authWrapper__2WYje","logoImg":"Auth_logoImg__3nk6Q","logoTitle":"Auth_logoTitle__2xviK"};